;<template>
    <div>
        <card-box class="order_list document-all-content" title="订单列表">
            <div class="hader_bu">
                <el-radio-group v-model="signRule" @change="get_data()">
                    <el-radio-button label="已支付"></el-radio-button>
                    <el-radio-button label="待支付"></el-radio-button>
                </el-radio-group>
            </div>

            <el-table
                    :data="myOrder"
                    header-row-class-name="myOrder-header"
                    row-class-name="order"
                    class="myOrder_tb myOrder_tb_s"
                    stripe
                    v-loading="loading"
                    :header-cell-style="{height: '40px',background:'rgba(245,247,246,1)', color:'#278E60'}"
            >
                <template slot="empty" class="tep_img">
                    <div style="padding-top: 30px">
                        <img src="@/assets/img/nullDate.png" style="width: 285px;height: 145px; margin-left: -67px;"/>
                        <p style="color:rgba(49,202,132,1);font-size: 18px;margin: 0">暂无数据</p>
                    </div>
                </template>
                <el-table-column width="250" prop="id" align="center" label="订单号" key="1"></el-table-column>
                <el-table-column prop="mealName" align="center" label="套餐名称" key="2"></el-table-column>
                <el-table-column prop="createDate" align="center" label="购买时间"
                                 v-if="signRule == '已支付'" key="3"></el-table-column>
                <el-table-column prop="createDate" align="center" label="创建时间"
                                 v-if="signRule == '待支付'" key="4"></el-table-column>
                <el-table-column align="center" width="100" label="金额" key="5">
                    <template slot-scope="scope"><i class="iconfont icon-renminbidanjia2 i_fon_s"></i>{{scope.row.orderAmount}}
                    </template>
                </el-table-column>
                <el-table-column prop="order" align="center" label="发票状态" v-if="signRule == '已支付'" key="6">
                    <template slot-scope="scope">
                        {{invoiceState[scope.row.invoiceState]}}
                    </template>
                </el-table-column>
                <el-table-column prop="order" align="center" label="操作" key="7">
                    <template slot-scope="scope">
                        <el-button v-if="signRule == '已支付' && scope.row.invoiceState != 1"
                                   icon="iconfont iconfont_one icon-guolufeifapiao"
                                   type="text"
                                   @click="add_invoice(scope.row)"
                        >申请发票
                        </el-button>
                        <el-button v-if="signRule == '已支付' && scope.row.invoiceState == 1"
                                   icon="iconfont iconfont_one icon-guolufeifapiao"
                                   type="text"
                                   @click="query_invoice(scope.row)"
                        >查看发票
                        </el-button>
                        <el-button v-if="signRule == '待支付'"
                                   icon="iconfont iconfont_one icon-zhifushezhibeifen2"
                                   type="text"
                                   @click="get_pay(scope.row)"
                        >去支付
                        </el-button>
                        <el-button
                                @click="del(scope.row)"
                                icon="el-icon-delete"
                                type="text"
                        >删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </card-box>
        <el-pagination
                id="guang_b"
                :hide-on-single-page="hide_pagination"
                background
                :page-sizes="[5, 10, 20, 50]"
                :page-size="pageSize"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                layout="prev, pager, next,sizes,jumper"
                :total="pages_total"
        ></el-pagination>
    </div>
</template>

<script>
    export default {
        name: "myOrder",
        data() {
            return {
                pageSize: 5,
                pageNum: 1,
                pages_total: 0,
                loading: false,
                hide_pagination: false,
                myOrder: [],
                order_status: {
                    0: "待支付",
                    1: "已完成",
                    2: "已取消"
                },
                invoiceState:{
                    null:'未申请',
                    0:'未申请',
                    1:'已申请'
                },
                meal_status: {
                    "0": {
                        txt: "已结束",
                        color: "#A5A5A5"
                    },
                    "1": {
                        txt: "使用中",
                        color: "#1384DA"
                    },
                    "2": {
                        txt: "未使用",
                        color: "#21AA6B"
                    },
                    "-1": {
                        txt: "",
                        color: ""
                    }
                },
                signRule: '已支付'
            }
        },
        mounted() {

        },
        created() {
            if (this.$route.params.signRule == '待支付') {
                this.signRule = '待支付'
            }
            this.getOrders();
        },
        methods: {
            get_data() {
                this.pageNum = 1
                this.pages_total =0
                this.myOrder = []
                this.getOrders();
            },
            add() {
                this.$message({
                    message: '即将开放,敬请期待.对您造成的不便,敬请谅解.',
                    type: "warning"
                });
            },
            add_invoice(item){
                this.$router.push({name: 'apply_for_invoice',params: {id: item.id,orderCode:item.orderCode ,orderAmount:item.orderAmount}})
            },
            query_invoice(item){
                this.$router.push({name: 'xq_invoice',params: {invoiceId: item.invoiceId,id: item.id}})
            },
            get_pay(item) {
                this.$router.push({name: 'paymentMethod', params: {code: item.setmealCode, id: item.id}})
            },
            getOrders() {
                this.loading = true
                if (this.signRule == '已支付') {
                    this.status = 1
                } else {
                    this.status = 0
                }
                this.$SIF.httpPost({
                    url: this.$SIF._serve.order + "/appOrderController/pageOrderStatus",
                    data: {
                        entity: {
                            status: this.status,
                        },
                        pageBean: {
                            pageSize: this.pageSize,
                            pageNum: this.pageNum
                        }
                    },
                    succFun: res => {
                        this.loading = false
                        if (!res.data) {
                            this.myOrder = []
                            return
                        }
                        var dt = [], meal = {}, list = res.data.list;
                        this.pages_total = res.data.total;
                        if (list) {
                            for (var i = 0; i < list.length; i++) {
                                list[i].mealStatus = meal[list[i].id] ? meal[list[i].id] : list[i].status == 1 ? "0" : "-1";
                                dt.push(list[i]);
                            }
                        }
                        this.myOrder = dt;

                    },
                    failFun: res => {
                        this.loading = false
                    }
                });
            },
            handleCurrentChange(val) {
                this.pageNum = val;
                this.getOrders();
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getOrders();
            },
            del(item) {
                this.loading = true
                this.$SIF.httpPost({
                    url: this.$SIF._serve.order + "/delete/upStatus",
                    data: {
                        id: item.id,
                        status: -1
                    },
                    succFun: res => {
                        const totalPage = Math.ceil((this.pages_total - 1) / this.pageSize) // 总页数
                        this.pageNum = this.pageNum > totalPage ? totalPage : this.pageNum
                        this.pageNum = this.pageNum < 1 ? 1 : this.pageNum
                        this.getOrders(this.pageNum);
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.loading = false
                    },
                    failFun: res => {
                        this.loading = false
                    }
                });
            }
        }
    }
</script>

<style scoped type="text/css">
    .child {
        height: calc(100% - 50px);
    }

    .document-all-content {
        height: 100%;
    }

    .hader_bu {
        width: 100%;
        /*position: fixed;*/
        padding: 10px 20px;

    }

    .hader_bu .el-radio-button {
        width: 60px;
        height: 24px;
        border-radius: 14px;

        padding: 0;
        text-align: center;
        line-height: 24px;
        margin-right: 20px;
    }

    .hader_bu >>> .el-radio-button__inner {
        border: none;
        padding: 0;
    }

    .is-active >>> .el-radio-button__inner {
        color: rgba(49,202,132,1);
        background: #ffffff;
        box-shadow: none;
    }

    .is-active {
        border: 1px solid rgba(49,202,132,1);
    }

    .myOrder_tb {
        height: calc(100% - 50px);
        width: 96.9% !important;
        margin: 0 auto;
        box-shadow: 2px 2px 16px 0px rgba(187,187,187,0.14);
    }

    .myOrder_tb_s >>> .el-table__row {
        height: 40px;
    }
</style>